import React, { createContext, useContext, useReducer } from 'react'
import { faker } from '@faker-js/faker';
import { cartReducer, productReducer } from './Reducers';

const Cart=createContext();
faker.seed(100);

const Context = ({children}) => {

    const products = [...Array(21)].map(() => ({
      id: faker.datatype.uuid(),
      name: faker.commerce.productName(),
      price: faker.commerce.price(),
      image: faker.image.fashion(640,480,true),
      inStock: faker.datatype.number({

        'min':0,
        'max':8
      }), 
      ratings: faker.random.numeric([1, 2, 3, 4, 5]),
    }));

       const [state,dispatch]= useReducer(cartReducer,{
        products:products,
        cart:[],
       });

       const [productState, productDispatch] = useReducer(productReducer ,{
        byStock:false,
        byRating:0,
        searchQuery:"",
       })

  return <Cart.Provider value={{state,dispatch,productState,productDispatch}}>{children}</Cart.Provider>
}

export default Context;

export const CartState=()=>{
  return useContext(Cart);
}